import { useNavigate, useParams } from "react-router-dom";
import { BigButton } from "../design/BigButton";
import { Card } from "../design/BigButton";
import { MascotBubble } from "../design/MascotBubble";

export function ComingSoonScreen() {
  const navigate = useNavigate();
  const { profileId } = useParams();
  return (
    <div className="wmleye-app coming-soon" data-testid="coming-soon">
      <Card>
        <MascotBubble text="This part is coming soon! Let's play something else for now." />
        <div style={{ marginTop: 24 }}>
          <BigButton onClick={() => navigate(`/child/${profileId}/home`)} data-testid="coming-soon-back">
            ← Back home
          </BigButton>
        </div>
      </Card>
    </div>
  );
}
